import type { FC, MouseEvent as ReactMouseEvent, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

import { AgentChatLinkButton, getChildrenText } from './AgentChatLinkButton'

interface SoapLinkButtonProps {
  children?: ReactNode
  className?: string
  onLinkClick?: () => void
  queryParams?: string
  soapId: string
}

/**
 * SOAP link button to open SOAP in a new tab via Agent Chat
 */
export const SoapLinkButton: FC<SoapLinkButtonProps> = ({
  soapId,
  children,
  className,
  onLinkClick,
  queryParams,
}) => {
  const { t } = useTranslation('Common')

  const handleClick = (e: ReactMouseEvent) => {
    e.preventDefault()
    onLinkClick?.()
    const url = queryParams
      ? `/soap/${soapId}?${queryParams}`
      : `/soap/${soapId}`
    window.open(url, '_blank')
  }

  const tooltipContent = t('Common:VIEW_SOAP')
  const ariaLabel = getChildrenText(children) || tooltipContent

  return (
    <AgentChatLinkButton
      ariaLabel={ariaLabel}
      className={className}
      tooltipContent={tooltipContent}
      onClick={handleClick}
    />
  )
}
